import { render, staticRenderFns } from "./Spbj.vue?vue&type=template&id=27b3a3a6&scoped=true&"
import script from "./Spbj.vue?vue&type=script&lang=js&"
export * from "./Spbj.vue?vue&type=script&lang=js&"
import style0 from "./Spbj.vue?vue&type=style&index=0&id=27b3a3a6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b3a3a6",
  null
  
)

export default component.exports